<template>
  <div
    style="width: 100%; display: flex; flex-direction: column; justify-content: center; padding: 10px;"
  >
    <v-radio-group
      v-model="typeOfPeriod"
      inline
      @change="onChange"
    >
      <v-row
        style="display: flex; flex-direction: row; justify-content: center;"
      >
        <v-col cols="auto">
          <v-radio
            :label="$t('dashboard.e4.periods.all')"
            value="all"
            default
          />
        </v-col>
        <v-col cols="auto">
          <v-radio
            :label="$t('dashboard.e4.periods.year')"
            value="year"
          />
        </v-col>
        <v-col cols="auto">
          <v-radio
            :label="$t('dashboard.e4.periods.specific')"
            value="specific"
          />
        </v-col>
      </v-row>
    </v-radio-group>

    <v-row
      v-if="typeOfPeriod === 'year'"
      style="display: flex; flex-direction: row; justify-content: center;"
    >
      <v-col
        class="modalColPadding"
        cols="4"
      >
        <VSelect
          :items="yearsList"
          :label="$t('dashboard.e4.periods.year')"
          outlined
          @change="computePeriodWithYear"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="typeOfPeriod === 'specific'"
      style="display: flex; flex-direction: row; justify-content: center; "
    >
      <v-col

        style="display: flex; justify-content: center;"
      >
        <VDatePicker
          v-model="rangeOfPeriod.start"
          :value="rangeOfPeriod"
          :label="$t('dashboard.e4.periods.startDate')"
          @change="onChange"
        />
      </v-col>
      <v-col

        style="display: flex; justify-content: center;"
      >
        <VDatePicker
          v-model="rangeOfPeriod.end"
          :value="rangeOfPeriod"
          :label="$t('dashboard.e4.periods.endDate')"
          @change="onChange"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker.vue';

export default {
    name: 'FilterDatesForm',
    components: {
        VSelect,
        VDatePicker,
    },
    data() {
        return {
            typeOfPeriod: 'all',
            rangeOfPeriod: {
                start: '',
                end: '',
            },
        };
    },
    computed: {
        yearsList() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let year = currentYear; year >= 2020; year -= 1) {
                years.push(year);
            }
            return years;
        },
    },
    watch: {
        typeOfPeriod() {
            this.rangeOfPeriod.start = '';
            this.rangeOfPeriod.end = '';
        },
    },
    methods: {

        computePeriodWithYear(year) {
            const start = new Date(`${year}-01-01T00:00:00Z`).toISOString();
            const end = new Date(`${year}-12-31T23:59:59Z`).toISOString();

            this.rangeOfPeriod.start = start;
            this.rangeOfPeriod.end = end;
            this.onChange();
        },
        onChange() {
            const payload = {
                typeOfPeriod: this.typeOfPeriod,
                rangeOfPeriod: this.rangeOfPeriod,
            };

            this.$emit('onChange', payload);
        },
    },
};

</script>
